// Chakra imports
import { Portal, Box, useDisclosure, Icon } from "@chakra-ui/react";
import { callApi } from "apiServices/callApi";
import Footer from "components/footer/FooterAdmin";
// Layout components
import Navbar from "components/navbar/NavbarAdmin";
import Sidebar from "components/sidebar/Sidebar";
import { environments } from "constants/environments";
import { useAuth } from "contexts/auth";
import { SidebarContext } from "contexts/SidebarContext";
import { IApiMetaData } from "interfaces/apiMetaData";
import { useEffect, useState } from "react";
import { FaHashtag } from "react-icons/fa";
import { Route, Routes, Navigate } from "react-router-dom";
import routes from "routes";
import Category from "views/home/category";
import Chatbot from "views/home/chat";

// Custom Chakra theme
export default function Home(props: { [x: string]: any }) {
  const { ...rest } = props;
  // states and functions
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const { sharedData } = useAuth()
  const categoriesAPI = environments.domain + sharedData?.apisList?.Category?.General
  const [data, setData] = useState<any[]>([]);
  const [dataRoutes, setDataRoutes] = useState<any[]>([]);

  
  const perparRouts = (name: string,id: string) => {


    let rou =  {
     name: name,
     layout: "/home",
     path: name,
     icon: (
       <Icon
         as={FaHashtag}
         width="20px"
         height="20px"
         color="inherit"
       />
     ),
     element: <Category id={id}/>,
     visibleMenu: true,
     secondary: true,
   }

   return rou 
  }
    
    
  useEffect(() => {
    const getData = async () => {
      const pagination = { paginationcurrent: 1, paginationlimit: 200, paginationtotal: 0, }

      const response: IApiMetaData = await callApi("GET", categoriesAPI, {}, pagination,{select:"name"});
      let arr = response?.Data?.Content?.map((item: any) => perparRouts(item?.name,item?._id))
      setDataRoutes(() => [...routes,...arr])
      
      
      if (response.Status === 200) {
        setData(() => response.Data.Content);
      }
    };
    getData();
  }, [])

  
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== "/home/full-screen-maps";
  };
  const getActiveRoute = (routes: RoutesType[]): string => {
    let activeRoute = "CIU UK";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        activeRoute = routes[i].name;
        
        return activeRoute;
      }
    }
    return activeRoute;
  };

  const getActiveNavbar = (routes: RoutesType[]): boolean => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary || false;
      }
    }

    return activeNavbar;
  };
  const getActiveNavbarText = (routes: RoutesType[]): string | boolean => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].name;
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes: RoutesType[]): any => {
    
    return routes.map((route: RoutesType, key: any) => {
      if (route.layout === "/home") {
        return (
          <Route
            path={route.path}
            element={route.element}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = "ltr";
  const { onOpen } = useDisclosure();
  return (
    <Box>
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
        }}
      >
        <Sidebar routes={routes} display="none" {...rest} />
        <Box
          float="right"
          minHeight="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          w={{ base: "100%", xl: "calc( 100% - 290px )" }}
          maxWidth={{ base: "100%", xl: "calc( 100% - 290px )" }}
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
        >
          <Portal>
            <Box>
              <Navbar
                onOpen={onOpen}
                logoText={""}
                brandText={getActiveRoute(routes)}
                secondary={getActiveNavbar(routes)}
                message={getActiveNavbarText(routes)}
                fixed={fixed}
                {...rest}
              />
            </Box>
          </Portal>

          {getRoute() ? (
            <Box
              mx="auto"
              p={{ base: "20px", md: "30px" }}
              pe="20px"
              minH="100vh"
              pt="50px"
            >
              <Routes>
                {getRoutes(dataRoutes)}
                <Route path="/" element={<Navigate to="/home/favorites" replace />} />
              </Routes>
            </Box>
          ) : null}
          <Box>
          <Chatbot />

            <Footer />
          </Box>
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
